'use strict';

var ModalManager = require('../Widgets/ModalManager');
/**
 * Contains event handler lists for success, failure, and complete events.
 * Adds checkResponseHeaders as the first success event.
 */
var EventsHandler = require('../Events/EventsHandler');

var Base = function(){};
Base.prototype = {
    contentContainer: null,
    evaluateJavascript: true,
    ajaxStorage: null,
    asynchronous: true,
    cleanupRequestAdded: false,
    cleanupStorageAdded: false,

    submitEvents: null,
    successEvents: null,
    completeEvents: null,
    failureEvents: null,

    /*
        Public Getters / Setters
    */
    setContentContainer : function(container) {
        this.contentContainer = container;
    },
    getContentContainer : function() {
        return this.contentContainer;
    },

    setEvaluateJavascript: function(evalScript){
        this.evaluateJavascript = evalScript;
    },
    getEvaluateJavascript: function(){
        return this.evaluateJavascript;
    },

    /*
        Public Methods
    */
    addCompleteEvent: function(func){
        this.completeEvents.addEvent(func);
    },

    addFailureEvent: function(func){
        this.failureEvents.addEvent(func);
    },

    /*
        Abstract Methods
    */
    getContent: function(){
        throw 'MITS.AjaxAPI.Base.getContent is abstract and must be overridden.';
    },

    /*
        Protected Methods
    */
    initializeEventHandlers: function(){
        this.ajaxStorage = document.createElement('div');

        this.submitEvents = new EventsHandler();
        this.successEvents = new EventsHandler();
        this.completeEvents = new EventsHandler();
        this.failureEvents = new EventsHandler();
        this.failureEvents.addEvent(function(jqXHR, textStatus, errorThrown){
            if(jqXHR){
                console.error('request failed with status ' + textStatus, errorThrown);
            }
        });

        this.failureEvents.addEvent(this.handleErrorResponse.bind(this));
        this.successEvents.addEvent(this.checkResponseHeaders.bind(this));
        this.successEvents.addEvent(this.handleResponse.bind(this)); // since this only happens on success the div will only be replaced on success... we opted into this manually in ImmediateRequest
    },

    checkResponseHeaders: function(data, status, jqXHR) {
        if(jqXHR){
            if (jqXHR.getResponseHeader('MITS_AjaxResponse_CloseModal')) {
                this.completeEvents.skipNextExecution();
                try {
                    ModalManager.getCurrentModal().deactivate();
                } catch (e) {
                    console.error(e);
                }
            }
        }
    },

    getAjaxLoadDiv: function(){
        if(this.getContentContainer()){
            return this.contentContainer;
        } else {
            return this.ajaxStorage;
        }
    },

    handleResponse: function(data){
        var ajaxLoadDiv = this.getAjaxLoadDiv();
        var $resultsContainer = jQuery(ajaxLoadDiv);
        if(data) {
            // .html() executes the script tags
            $resultsContainer.html(data);
        }
        else {
            // data is undefined when the success handlers are called directly
            // this will go and re-execute the scripts already on the page, needed in order to reinitialize the modal wizard
            $resultsContainer
                .find('script')
                .each(function () {
                    eval(jQuery(this).text());
                });
        }
    },

    handleErrorResponse: function(jqXHR){
        var ajaxLoadDiv = this.getAjaxLoadDiv();
        var $resultsContainer = jQuery(ajaxLoadDiv);
        if (!(!(jqXHR) || !(jqXHR.responseText))) {
            $resultsContainer.html(jqXHR.responseText);
        }
    },

    cleanupStorage: function(){
        this.ajaxStorage.innerHTML = '';
    }

};

module.exports = Base;


//////////////////
// WEBPACK FOOTER
// ./mits/AjaxAPI/Base.js
// module id = 4
// module chunks = 0